// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payments-attachments-metafield-header{color:#506784}.payments-attachments-metafield-header--required:after{content:\"*\";display:inline-block;color:var(--color-rosso);font-size:14px;margin-left:4px;transform:translateY(3px);line-height:1}", ""]);
// Exports
module.exports = exports;
